import {Model} from '@chaysehartsuff/active-html';

export default class UserImageFolders extends Model {
    id;
    user_id;
    display_name;
    parent_user_image_folder_id;
    created_at;
    updated_at;
}